import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=756e203d&scoped=true&lang=pug&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&id=756e203d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756e203d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756e203d')) {
      api.createRecord('756e203d', component.options)
    } else {
      api.reload('756e203d', component.options)
    }
    module.hot.accept("./invite.vue?vue&type=template&id=756e203d&scoped=true&lang=pug&", function () {
      api.rerender('756e203d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/dialog/invite.vue"
export default component.exports